import requests from "API/propertiesRequests";
import { useEffect, useState } from "react";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import MKBox from "components/MKBox";
import HorizontalTeamCard from "components/Cards/TeamCards/HorizontalTeamCard";
import { Grid, Button } from "@mui/material";

function LatestAdded() {
  const [data, setData] = useState([]);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    fetch(requests.getLatestAdded()).then(async (response) => {
      if (response.ok) {
        setData(await response.json());
      }
    });
  }, []);
  const numberOfItems = showMore ? data.length : 4;
  // console.log(data);
  return (
    <>
      <MKBox
        component="section"
        variant="gradient"
        position="relative"
        py={6}
        px={{ xs: 2, lg: 0 }}
        mx={-2}
        style={{ backgroundColor: "#344767" }}
      >
        <Container>
          <Grid container>
            <Grid item xs={12} md={8} sx={{ mb: 6 }}>
              <MKTypography variant="h2" color="white">
                Últimos Agregados
              </MKTypography>
              <MKTypography variant="body2" color="white" opacity={0.8}>
                Consulte los últimos Inmuebles registrados
              </MKTypography>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            {data.slice(0, numberOfItems).map((property) => (
              <Grid item xs={12} lg={6}>
                <MKBox mb={1}>
                  <a href={`/details/${property.id}`}>
                    <HorizontalTeamCard
                      image={`https://administracionbiugb.ugb.edu.sv${
                        property.imagesproperty_set.map((item) => item.image_property)[0]
                      }`}
                      name={
                        <MKTypography variant="h3" color="inherit">
                          {property.name}
                        </MKTypography>
                      }
                      position={{
                        color: "info",
                        label: [
                          <MKTypography variant="button">
                            {new Date(property.created_at).getDay()} &nbsp;
                            {new Date(property.created_at).toLocaleString("default", {
                              month: "long",
                            })}
                            , &nbsp;
                            {new Date(property.created_at).getFullYear()}
                          </MKTypography>,
                        ],
                      }}
                      description={
                        <>
                          <div>
                            <span className="material-icons-outlined">location_on</span>
                            {property.street}, {property.suburb?.name}
                          </div>
                          Valor Cultural: {property.cultural_value}
                        </>
                      }
                    />
                  </a>
                </MKBox>
              </Grid>
            ))}
          </Grid>
          <br />
          <Grid
            container
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            <Button
              onClick={() => setShowMore(!showMore)}
              type="submit"
              style={{ backgroundColor: "#E0EBFB" }}
            >
              <MKTypography variant="body2" color="inherit">
                {showMore ? "Mostrar menos" : "Mostrar más"}
                <span className="material-icons-outlined">refresh</span>
              </MKTypography>
            </Button>
          </Grid>
        </Container>
      </MKBox>
      <br />
      <br />
    </>
  );
}

export default LatestAdded;
